const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfHappiness extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfHappiness,
            "Each civilization scores 2 culture per happy face (no more than 16 points) and loses 2 culture per discontent worker.",
            {}
        )
    }
}

module.exports = ImpactOfHappiness;